export default __webpack_public_path__ + "static/media/lb-sbo.c968b396.webp";